<template>

    <div class="card-styles--setting card-styles--player">
        <h2>2. Imagen</h2>
        <div class="playername-settings-wrap">
            
                <div>
                    <button @click="openFilePlayer" class="uploadImageButton button1">
                        <span v-if="cardColors.playerImageLink == ''">Subir Imagen</span>
                        <span v-else>Subir otra imagen</span>
                    </button>
                    
                    <input type="file" id="playerImageUpload" accept="image/*" @change="uploadImagePlayer" style="display: none" ref="fileInput">
                    <p v-if="errorMessage">{{ errorMessage }}</p>

                </div>

                

                <div v-if="showPreviewPlayerImage">
                    <div class="flex-setting">
                        <div class="inputSlider standalone-setting" v-if="cardColors.playerImageLink">
                            <label>Zoom</label>
                            <input type="range" :value="playerImgResizeFactor" step="0.001" min="0.1" max="5" @input="playerImgResizeFactorChange">
                        </div>
                        <div class="image-editing-infobox">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                            </svg>
                            Haz click en la imagen para reposicionarla.
                            <svg class="arrow-helper-svg" width="830px" height="479px" viewBox="0 0 830 479" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Desktop-HD-Copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-323.000000, -513.000000)">
                                    <g id="curved-arrow-icon" transform="translate(738.000000, 752.500000) scale(1, -1) translate(-738.000000, -752.500000) translate(323.000000, 513.000000)" fill="#fec552">
                                        <path d="M467.221318,234.109334 L441.491068,139.434276 C440.544858,135.881741 442.271275,132.132882 446.786519,129.216063 C454.953798,123.943354 469.196737,123.382427 478.559228,127.982025 L822.29877,296.615252 L824.838595,298.101707 C832.756872,303.486603 831.412259,311.489155 821.850566,315.939173 L478.111024,476.121106 C473.147575,478.374161 466.557311,479.477317 459.801046,478.804205 C447.616527,477.570166 439.499048,470.988628 441.690269,464.135975 L467.320919,383.895428 C437.473829,381.941533 404.920912,377.753282 371.421786,371.405463 C284.005336,354.867477 188.886411,323.343404 116.908112,277.60919 C44.2160048,231.426235 -5.02007389,170.836816 0.408178887,96.6075316 C2.35039777,69.5708705 11.6132878,40.7579419 29.6742634,10.2715823 C31.8986851,5.33542842 39.3355574,1.4369887 48.8474499,0.801271907 C61.1979699,-0.0214204087 72.4030789,4.95212859 73.8472929,11.8982694 C93.6512855,105.460823 157.727909,159.711772 236.943879,191.207799 C307.743567,219.366313 391.640783,229.864989 467.221318,234.109334 Z" id="Shape" transform="translate(415.000000, 239.856139) rotate(360.000000) translate(-415.000000, -239.856139) "></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>

                    
                    

                    <div class="removebg-wrapper">
                        <button class="removebg-button button2"
                                v-if="!imageIsTooLarge"
                                href="#"
                                role="button"
                                @click.prevent="noBgFnFromSetting"
                            >
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-transparency" viewBox="0 0 16 16">
                                <path d="M0 6.5a6.5 6.5 0 0 1 12.346-2.846 6.5 6.5 0 1 1-8.691 8.691A6.5 6.5 0 0 1 0 6.5Zm5.144 6.358a5.5 5.5 0 1 0 7.714-7.714 6.5 6.5 0 0 1-7.714 7.714Zm-.733-1.269c.363.15.746.261 1.144.33l-1.474-1.474c.069.398.18.78.33 1.144Zm2.614.386a5.47 5.47 0 0 0 1.173-.242L4.374 7.91a5.958 5.958 0 0 0-.296 1.118l2.947 2.947Zm2.157-.672c.297-.166.577-.36.838-.576L5.418 6.126a6.016 6.016 0 0 0-.587.826l4.35 4.351Zm1.545-1.284c.216-.26.41-.54.576-.837L6.953 4.83a5.97 5.97 0 0 0-.827.587l4.6 4.602Zm1.006-1.822c.121-.374.204-.766.242-1.172L9.028 4.078c-.386.063-.76.163-1.118.296l3.823 3.824Zm.186-2.642a5.463 5.463 0 0 0-.33-1.144 5.46 5.46 0 0 0-1.144-.33l1.474 1.474Z"/>
                            </svg>  -->
                            quitar fondo
                        </button>

                        <button v-tooltip.top.focus="'Only available for images under 5MB'" class="removebg-button remove-button-notavailable"
                                v-else
                                href="#"
                                role="button"
                            ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-transparency" viewBox="0 0 16 16">
                            <path d="M0 6.5a6.5 6.5 0 0 1 12.346-2.846 6.5 6.5 0 1 1-8.691 8.691A6.5 6.5 0 0 1 0 6.5Zm5.144 6.358a5.5 5.5 0 1 0 7.714-7.714 6.5 6.5 0 0 1-7.714 7.714Zm-.733-1.269c.363.15.746.261 1.144.33l-1.474-1.474c.069.398.18.78.33 1.144Zm2.614.386a5.47 5.47 0 0 0 1.173-.242L4.374 7.91a5.958 5.958 0 0 0-.296 1.118l2.947 2.947Zm2.157-.672c.297-.166.577-.36.838-.576L5.418 6.126a6.016 6.016 0 0 0-.587.826l4.35 4.351Zm1.545-1.284c.216-.26.41-.54.576-.837L6.953 4.83a5.97 5.97 0 0 0-.827.587l4.6 4.602Zm1.006-1.822c.121-.374.204-.766.242-1.172L9.028 4.078c-.386.063-.76.163-1.118.296l3.823 3.824Zm.186-2.642a5.463 5.463 0 0 0-.33-1.144 5.46 5.46 0 0 0-1.144-.33l1.474 1.474Z"/>
                            </svg> quitar fondo
                        </button>

                        <div class="settings-info-box">
                            <div v-if="imageIsTooLarge">
                                Nuestro programa sólo admite imágenes con un tamaño inferior a 5MB.
                            </div>
                        </div>

                    </div>

                    <!-- <div class="useoutline-wrapper">
                        <div>
                            <button @click="updateInputImageOutline" class="button2" :class="{useImageOutlineChecked : useImageOutline}">
                                <div class="checkbox--slider" >
                                    <div class="checkbox--slider-inner"></div>
                                </div>
                                <span>Borde</span>
                            </button>
                        </div>
                        <div v-show="useImageOutline">
                            <input type="number" :value="imageOutlineWidth" min="1" step="1" @input="updateInputImageOutlineWidth" />
                        </div>

                        <div v-show="useImageOutline">
                            <LvColorpicker :value="imageOutlineColor" withoutInput hidePalette @input="setOutlineColor" />
                        </div>
                    </div> -->
                </div>

                <button @click="showImageAdvanced = !showImageAdvanced" class="button4" v-if="showPreviewPlayerImage">
                    <svg v-if="!showImageAdvanced" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                    </svg>
                    <span v-if="!showImageAdvanced">mas ajustes imagen</span>
                    <span v-else>cerrar ajustes</span>
                </button>
                
                <!-- <button @click="showPreviewPlayerImage = true" v-if="imgSrc">Advanced</button> -->
            
        </div>

        <div class="image-editing--advanced" v-show="showImageAdvanced">

            <div class="image-editing-sliders">

                <div class="slider-range-wrap--outer">
                    <div class="useoutline-wrapper">
                        <div>
                            <button @click="updateInputImageOutline" class="button2" :class="{useImageOutlineChecked : useImageOutline}">
                                <div class="checkbox--slider" >
                                    <div class="checkbox--slider-inner"></div>
                                </div>
                                <span>Borde</span>
                            </button>
                        </div>
                        <div v-show="useImageOutline">
                            <input type="number" :value="imageOutlineWidth" min="1" step="1" @input="updateInputImageOutlineWidth" />
                        </div>

                        <div v-show="useImageOutline">
                            <LvColorpicker :value="imageOutlineColor" withoutInput hidePalette @input="setOutlineColor" />
                        </div>
                    </div>
                </div>

                <div class="slider-range-wrap--outer">
                    <div class="slider-range-wrap">
                        <label>Escala de grises:</label><input type="number" max="100" min="0" v-model="imageGrayscale" @input="updateGrayscale">
                    </div>
                    <div class="inputSlider">
                        <input @input="updateGrayscale" type="range" min="0" max="100" v-model="imageGrayscale">
                    </div>
                </div>

                <div class="slider-range-wrap--outer">
                    <div class="slider-range-wrap">
                        <label>Sepia:</label>
                        <input type="number" max="100" min="0" v-model="imageSepia" @input="updateSepia">
                    </div>
                    <div class="inputSlider">
                        <input @input="updateSepia" type="range" min="0" max="100" v-model="imageSepia">
                    </div>
                </div>

                <div class="slider-range-wrap--outer">
                    <div class="slider-range-wrap">
                        <label>Luminosidad:</label>
                        <input type="number" max="2" min="0" step="0.05" v-model="imageBrightness" @input="updateBrightness">
                    </div>
                    <div class="inputSlider">
                        <input @input="updateBrightness" type="range" min="0" max="2"  step="0.05" v-model="imageBrightness">
                    </div>
                </div>

                <div class="slider-range-wrap--outer">
                    <div class="slider-range-wrap">
                        <label>Contraste:</label>
                        <input type="number" max="2" min="0" step="0.05" v-model="imageContrast" @input="updateContrast">
                    </div>
                    <div class="inputSlider">
                        <input @input="updateContrast" type="range" min="0" max="2"  step="0.05" v-model="imageContrast">
                    </div>
                </div>

                <div class="slider-range-wrap--outer">
                    <div class="slider-range-wrap">
                        <label>Saturación:</label>
                        <input type="number" max="4" min="0" step="0.05" v-model="imageSaturation" @input="updateSaturation">
                    </div>
                    <div class="inputSlider">
                        <input @input="updateSaturation" type="range" min="0" max="4"  step="0.05" v-model="imageSaturation">
                    </div>
                </div>

                <!-- <div class="slider-range-wrap--outer">
                    <button @click="updateflipHorizontal" :class="{useImageOutlineChecked : flipHorizontal}">
                        <div class="checkbox--slider" >
                            <div class="checkbox--slider-inner"></div>
                        </div>
                        <span>Flip Image</span>
                    </button>
                </div> -->

            </div>

            

        </div>

    </div>

</template>

<script>
// import PreviewPlayerImage from './PreviewPlayerImage.vue';
// import VueCropper from 'vue-cropperjs';
// import 'cropperjs/dist/cropper.css';
import Tooltip from 'lightvue/tooltip';
import LvColorpicker from 'lightvue/color-picker';

export default {
    props: ['playerImgResizeFactor','errorMessage','useImageOutline','imgSrc','showPreviewPlayerImage','playerImageLink','cardColors','croppedImage','imageIsTooLarge','imageOutlineColor','imageOutlineWidth'],

    data(){
        return {
            imageGrayscale: 0,
            imageSepia: 0,
            imageBrightness: 1,
            imageContrast: 1,
            imageSaturation: 1,
            flipHorizontal: false,
            showImageAdvanced: false,
            fileSizeTooBig: false
        }
    },

    components: {
        LvColorpicker
    },
    directives: {
        tooltip: Tooltip,
    },
    methods: {

        playerImgResizeFactorChange(event) {
            let data = event.target.value;
            this.$emit('playerImgResizeFactorChange',data);
        },

        updateflipHorizontal() {
            this.flipHorizontal = !this.flipHorizontal;
            this.$emit('updateflipHorizontal', this.flipHorizontal);
        },

        updateSaturation() {
            this.$emit('updateSaturation', this.imageSaturation);
        },

        updateContrast() {
            this.$emit('updateContrast', this.imageContrast);
        },

        updateBrightness() {
            this.$emit('updateBrightness', this.imageBrightness);
        },

        updateGrayscale() {
            this.$emit('updateGrayscale', this.imageGrayscale);
        },

        updateSepia() {
            this.$emit('updateSepia', this.imageSepia);
        },

        

        openFilePlayer() {
            this.$refs.fileInput.click();
        },

        

        uploadImagePlayer(event) {
            // if(event.target.files[0].size < 5 * 1024 * 1024) {
                console.log(event.target.files[0]);
                if(event.target.files[0] != undefined) {
                    this.$emit('changePlayerImage', event.target.files[0]);
                }
                
            // }

        },
        updateInputImageOutline() {

            let data = !this.useImageOutline

            this.$emit('updateInputImageOutline', data);
            
        },
        updateInputImageOutlineWidth(event) {

            let data = event.target.value

            this.$emit('updateInputImageOutlineWidth', data);

        },
        setOutlineColor(color) {
            let data = color;
            this.$emit('setOutlineColor', data);
        },
        cancelPlayerImageChild(){
            this.$emit('cancelPlayerImage');
        },
        closePreview() {
                console.log('we want to close');
                this.$emit('close-modal');
                if(this.cardColors.playerImageLink) {
                    console.log('we had an image')
                }
        },

        useCroppedImageFromPlayer() {
            let cropped = this.$refs.cropper.getCroppedCanvas();
            let croppedDataUrl = this.$refs.cropper.getCroppedCanvas().toDataURL();
            const data = {
                cropped,
                croppedDataUrl
            }
            console.log(cropped)
            this.$emit('useCroppedImageFromPlayer', data);
        },

        noBgFnFromSetting() {
            this.$emit('triggerNoBg')
            },

            

            modifyImg() {
                if(this.showSetting === 'player') {
                    this.active = true;
                }

                if(this.showSetting === 'club') {
                    this.activeEscudo = true;
                }
            },  

            cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.cardColors.playerImageLink = this.$refs.cropper.getCroppedCanvas().toDataURL();
      console.log(this.cardColors.playerImageLink)
    },




            onCrop(eventData) {
                //this.$nextTick(() => {
                const canvas = this.$refs.cropper.getCroppedCanvas();
                if (canvas) {
                    this.croppedImage = canvas.toDataURL('image/png'); // Adjust the format as needed

                    let calcH = canvas.width / 300;
                        
                    this.w = 300;
                    this.h = canvas.height / calcH;
                    // this.w = canvas.width;
                    // this.h = canvas.height;
                }
                //});
            },

        

       
    }
}
</script>

<style lang="less">

//  @import "../less/colors.less";

   #showPreviewPlayerImage {
        width: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 2rem 0rem;
    }

    #showPreviewPlayerImage-actions {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    #showPreviewPlayerImage-actions button {
        margin: 1rem;
    }
    #showPreviewPlayerImage-preview-window {
        max-width: 450px;
        margin: 1rem auto;
    }

    .actions {
    margin-top: 1rem;
    width: 100%;
}

.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}


.preview-area {
  width: 307px;
}

.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}

.preview-area p:last-of-type {
  margin-top: 1rem;
}

.preview {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}

.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}

.cropped-image img {
  max-width: 100%;
}

.img-cropper--wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

}

.img-cropper {
    max-width: 500px
}



.slider-range-wrap {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1rem;
    justify-content: space-between;
}
.slider-range-wrap input {
    width: 75px;
    margin-left: 1rem;
    height: 40px;
}

.slider-range-wrap label {
    margin: 0;
}

.slider-range-wrap--outer {
    padding: 1rem;
    margin-bottom: 2rem;
    border-radius: var(--radius_global);
    background: rgba(255,255,255,0.1);
    background: none;
    width: calc(50% - 1rem);
}
.image-editing-sliders {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-radius: var(--radius_global);
}

.checkbox--slider {
    width: 1.6rem;
    height: 1rem;
    border-radius: 20px;
    background: #323c84;
    position: relative;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.5rem;
}

.checkbox--slider-inner {
    height: calc(1rem - 0.5rem);
    width: calc(1rem - 0.5rem);
    border-radius: 50%;
    position: absolute;
    left: 0.25rem;
    top: 0.25rem;
    transition: transform 0.3s;
    background: var(--button_teal);
}

.useImageOutlineChecked {
    
    .checkbox--slider-inner {
        transform: translateX(0.6rem);
        opacity: 1;
        background: var(--base_orange);
        background: var(--button_gradient_orange);
    }
}

.image-editing-top {
    display: flex;
    margin-bottom: 2rem;
    justify-content: space-between;

    label {
        margin-top: 0
    }
}

.image-editing-top > div {
    display: flex;
    width: 100%;
    background: #6a7dee;
    flex-direction: column;
    border-radius: var(--radius_global);
    width: calc(33% - 1rem);
}

.image-editing-infobox {
    padding: 1rem 0.75rem;
    border-radius: var(--radius_global);
    margin: 2rem auto;
    position: relative;
    font-weight: 700;
    font-size: 0.85rem;
    text-align: center;

    svg:not(.arrow-helper-svg) {
        display: inline-block;
        vertical-align: middle;
        margin-right: 0.3rem;
    }

    svg.arrow-helper-svg {
        position: absolute;
        height: auto;
        width: 100%;
        max-width: 150px;
        top: -1rem;
        right: -1rem;
        display: none;
    }

}

.remove-button-notavailable {
    opacity: 0.7;
    cursor: not-allowed;
}

.lv-tooltip > * {
    background: white!important;
    text-align: center;
    font-weight: 700;
    color: var(--dark_blue)!important;
    font-size: 0.85rem;
    border-radius: var(--radius_global)
}

.removebg-wrapper {
    border-radius: var(--radius_global);
    padding: 1rem 0;
    display: flex;
    gap: 1rem;
    align-items: center;
    font-weight: 600;
    margin-bottom: 2rem;
}

.settings-info-box {
    flex: 1;
}

.useoutline-wrapper {
    display: flex;
    padding: 1rem 0;
    border-radius: var(--radius_global);
    align-items: center;
    gap: 0.75rem;

    input[type=number] {
        width: 75px;
        height: 40px;
    }
}

@media(max-width:430px) {
    .removebg-wrapper {
        flex-direction: column-reverse;
        align-items: flex-start;
    }

    .useoutline-wrapper {
        flex-wrap: wrap;

        & > div:first-child {
            width: 100%;
            margin-bottom: 2rem;
        }
    }
}

.flex-setting {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;

    & > div {
        flex: 1;
    }
}

@media(max-width:768px) {
    .flex-setting {
        display: block;

        & > div {
            width: 100%;
        }
    }   
}

</style>